
import React from "react";
import PointDisplay from "./PointDisplay";
import PuttingHelp from "./PuttingHelp";

interface ScoreDisplayProps {
  currentPoint: string;
  currentAttempt: number;
  maxAttempts: number;
  correctDistance: string;
  isPutting: boolean;
  isChipping: boolean;
  testId: string | null;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({
  currentPoint,
  currentAttempt,
  maxAttempts,
  correctDistance,
  isPutting,
  isChipping,
  testId
}) => {
  return (
    <>
      <PointDisplay 
        currentPoint={currentPoint}
        currentAttempt={currentAttempt}
        maxAttempts={maxAttempts}
        distance={correctDistance}
        isChippingTest={isChipping}
        getFormattedPoint={(point) => getFormattedPointForDisplay(point, testId)}
        currentLevel={2}
      />

      {isPutting && <PuttingHelp />}
    </>
  );
};

const getFormattedPointForDisplay = (point: string, testId: string | null): string => {
  // Bunker tests formatting in Level 2
  if (testId && testId.includes('bunker')) {
    if (testId === "bunker-court") {
      if (point === "D") return "5m";
      if (point === "E") return "8m";
      if (point === "F") return "12m";
      // Compatibilité avec les points du niveau 3
      if (point === "BunkerA") return "5m";
      if (point === "BunkerB") return "8m"; 
      if (point === "BunkerC") return "12m";
    } else if (testId === "bunker-long") {
      if (point === "D1") return "15m";
      if (point === "E1") return "20m";
      // Compatibilité avec les points du niveau 3
      if (point === "BunkerD") return "15m";
    }
  }

  // Special formatting for wedging points in Level 2
  if (testId && testId.includes('wedging')) {
    if (testId === "wedging-cercles") {
      if (point === "D") return "45m";
      if (point === "E") return "55m";
      if (point === "F") return "65m";
      if (point === "WedgingA") return "45m";
      if (point === "WedgingB") return "55m";
      if (point === "WedgingC") return "65m";
    } else if (testId === "wedging-mid") {
      if (point === "D1") return "75m";
      if (point === "E1") return "85m";
      if (point === "F1") return "95m";
    } else if (testId === "wedging-pente-gauche") {
      if (point === "D2") return "45m";
      if (point === "E2") return "55m";
      if (point === "F2") return "65m";
    }
  }
  
  // Special formatting for chipping points
  if (testId && testId.includes('chipping')) {
    if (testId === "chipping-plat") {
      if (point === "D") return "15m";
      if (point === "E") return "20m";
      if (point === "F") return "25m";
      if (point === "TerPlatA") return "15m";
      if (point === "TerPlatB") return "20m";
      if (point === "TerPlatC") return "25m";
    } else if (testId === "chipping-pente-droit") {
      if (point === "D1") return "15m";
      if (point === "E1") return "20m";
      if (point === "F1") return "25m";
    } else if (testId === "chipping-pente-gauche") {
      if (point === "D2") return "15m";
      if (point === "E2") return "20m";
      if (point === "F2") return "25m";
    } else if (testId === "chipping-roulee-plat") {
      if (point === "D3") return "5m";
      if (point === "E3") return "10m";
      if (point === "F3") return "15m";
    }
  }

  // For putting
  if (point === "D") return "1,2m";
  if (point === "E") return "1,5m";
  if (point === "F") return "3m";
  if (point === "D1") return "1,2m (pente en montée)";
  if (point === "E1") return "1,5m (pente en montée)";
  if (point === "F1") return "3m (pente en montée)";
  if (point === "D2") return "1,2m (pente en descente)";
  if (point === "E2") return "1,5m (pente en descente)";
  if (point === "F2") return "3m (pente en descente)";

  return point;
};

export default ScoreDisplay;
